const SolutionCard = (props) => {
  return (
    <li className="solution-item-card">
      <a href={props.ctaLink} rel="noopener noreferrer">
        <div className="solution-item-card-body">
          <img src={props.icon} alt={props.title} />
          <h3>{props.title}</h3>
          <p>{props.subtitle}</p>
        </div>
        <div className="solution-item-card-cta">
          <span className="boldTitle">View Details &rarr;</span>
        </div>
      </a>
    </li>
  );
};

export default SolutionCard;
